import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePickerComp from "themes/elements/DatePicker";
import InputComp from "themes/elements/Input";
import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function Education({ isEdit, open, setOpen, handleSave, seletedItem }) {
  const { selectedCounsilor, editQualification, expChangeLoading } =
    useSelector((state) => state.counsilor);

  const [education, setEducation] = useState({
    title: "",
    startDate: "",
    endDate: "",
    subTitle: "",
    recordId: null,
  });

  const reformatDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Correcting the order to Year-Month-Day
  };

  const handleChange = (field, value) => {
    if (field === "startDate" || field === "endDate") {
      value = reformatDate(value);
    }
    setEducation({ ...education, [field]: value });
  };

  const isValid = () => {
    return (
      education.title.length > 0 &&
      education.startDate &&
      education.endDate &&
      education.subTitle.length > 0
    );
  };

  const handleFormSave = () => {
    if (isValid()) {
      handleSave(isEdit ? "update" : "create", education, "education");
    } else {
      toast.warn("Please fill all the fields.");
    }
  };

  useEffect(() => {
    if (editQualification && isEdit && seletedItem) {
      setEducation({
        title: seletedItem?.course_name,
        startDate: seletedItem?.edu_start_date,
        endDate: seletedItem?.edu_end_date,
        subTitle: seletedItem?.board_name,
        recordId: seletedItem?.councilor_edu_info_id,
      });
    } else {
      setEducation({
        title: "",
        startDate: "",
        endDate: "",
        subTitle: "",
      });
    }
  }, [editQualification, isEdit, seletedItem, open]);

  const handleChangeDate = (field, value) => {
    // Check if the value is a valid date, specifying the expected format
    if (dayjs(value, "DD-MM-YYYY").isValid()) {
      const formattedDate = dayjs(value, "DD-MM-YYYY").format("YYYY-MM-DD");
      setEducation((prev) => ({ ...prev, [field]: formattedDate }));
    } else {
      setEducation((prev) => ({ ...prev, [field]: "" }));

      // Handle invalid date, maybe reset the date field or show an error
    }
  };

  const disableStartDate = (current) => {
    if (education.endDate) {
      return (
        current.isAfter(dayjs().endOf("day")) ||
        current.isAfter(dayjs(education.endDate, "YYYY-MM-DD"))
      );
    }
    return current.isAfter(dayjs().endOf("day"));
  };

  const disableEndDate = (current) => {
    if (education.startDate) {
      return (
        current.isAfter(dayjs().endOf("day")) ||
        current.isBefore(dayjs(education.startDate, "YYYY-MM-DD"))
      );
    }
    return current.isAfter(dayjs().endOf("day"));
  };

  return (
    <ModalComp
      title="Education"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          handleSecondaryBtn={handleFormSave}
          secondaryBtnLoading={expChangeLoading}
          primaryBtnText="Cancel"
          secondaryBtnText="Save"
          primaryBtnVariant="secondary"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className="flex gap-4 flex-column">
        <InputComp
          showCount
          maxLength={100}
          layoutClass="w-full"
          placeholder="Qualification name"
          label="Qualification name"
          value={education.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />
        <InputComp
          showCount
          maxLength={200}
          layoutClass="w-full"
          placeholder="Institution name"
          value={education.subTitle}
          onChange={(e) => handleChange("subTitle", e.target.value)}
          label="Institution name"
        />
        <div className="flex gap-4 align-center">
          <div className="flex flex-column gap-2 w-full">
            <label htmlFor="" className="input-label">
              From
            </label>
            <DatePickerComp
              disabledDate={disableStartDate}
              label="From"
              format="DD-MM-YYYY"
              value={
                education.startDate
                  ? dayjs(education.startDate).format("DD-MM-YYYY")
                  : null
              }
              onChange={(date) => handleChangeDate("startDate", date)}
            />
          </div>
          <div className="flex flex-column gap-2 w-full">
            <label htmlFor="" className="input-label">
              To
            </label>
            <DatePickerComp
              label="To"
              format="DD-MM-YYYY"
              value={
                education.endDate
                  ? dayjs(education.endDate).format("DD-MM-YYYY")
                  : null
              }
              disabledDate={disableEndDate}
              onChange={(date) => handleChangeDate("endDate", date)}
            />
          </div>
        </div>
      </div>
    </ModalComp>
  );
}

export default Education;
